/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../lib/@waca/dashboard-common/dist/api/PropertiesProviderAPI',
	'../../../widgets/livewidget/nls/StringResources'
], function(APIFactory, PropertiesProviderAPI, StringResources) {

	const PROP_ID_VALUES_AS_ROWS = 'valuesAsRows';
	const dropDownItems = [
		{ label: StringResources.get('showValuesAsRowLabel'), value: 'rowsAuto' },
		{ label: StringResources.get('showValuesAsColumnLabel'), value: 'columnsAuto' }
	];
	class ValuesAsRowsPropertyProvider {

		constructor({ content, dashboardAPI, features }) {
			this.content = content;
			this.visualization = features['Visualization'];
			// register self as a 'Properties' provider
			this.content && features['Properties'].registerProvider(this.getAPI());
			this.featureChecker = dashboardAPI && dashboardAPI.getGlassCoreSvc('.FeatureChecker');
		}

		getAPI() {
			if (!this._api) {
				this._api = APIFactory.createAPI(this, [PropertiesProviderAPI]);
			}
			return this._api;
		}

		destroy() {
			this.content = null;
			this.featureChecker = null;
		}

		getPropertyLayoutList() {
			return [];
		}

		getPropertyList() {
			const sectionId = this.featureChecker && this.featureChecker.checkValue('dashboard', 'PropertiesV2', 'enabled') ? 'chart' : 'visualization.chart';
			const propertyList = [];
			if (this._isSupported()) {
				propertyList.push( {
					id: PROP_ID_VALUES_AS_ROWS,
					editor: {
						sectionId: sectionId,

						uiControl: {
							type: 'DropDown',
							label:  StringResources.get('showValuesOn'),
							ariaLabel: StringResources.get('showValuesOn'),
							onChange: (propertyName, propertyValue) => {
								this.content.setPropertyValue(propertyName, propertyValue);
							},
							readOnly: true,
							options: dropDownItems
						}
					},
					onPropertyChange: {
						refresh: {
							data: true
						}
					},
					supportsUndoRedo: true,
					defaultValue: dropDownItems[1].value

				});
			}
			return propertyList;
		}

		reset() { }

		_isSupported() {
			return this.visualization && this.visualization.getType() === 'Crosstab';
		}
	}

	return ValuesAsRowsPropertyProvider;
});
